import React from 'react'
import _ from '/home/ps/root'
import './index.css'
import Part from '../../part'
import {
} from '../../../type'
// https://www.w3schools.com/howto/howto_js_fullscreen.asp
export const ID = 'f11'
export default class F11 extends Part {
  static ID = ID
  constructor (p, c) {
    super(p, c)
    this.state = {mode: 'F11'},
    this.elem = document.documentElement
  }
  enterFullscreen = () => {
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen()
    } else if (this.elem.mozRequestFullScreen) { /* Firefox */
      this.elem.mozRequestFullScreen()
    } else if (this.elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
      this.elem.webkitRequestFullscreen()
    } else if (this.elem.msRequestFullscreen) { /* IE/Edge */
      this.elem.msRequestFullscreen()
    }
    return {mode: 'ESC'}
  }
  exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen()
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen()
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen()
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen()
    }
    return {mode: 'F11'}
  }
  onClick = e => {
    console.log('WidgetF11.onClick')
    switch(this.state.mode) {
      case 'F11': this.setState(this.enterFullscreen()); break
      case 'ESC': this.setState(this.exitFullscreen()); break
    }
  }
  render = () => {
    return (
      <div id={ID} onClick={this.onClick}>
        {this.state.mode}
      </div>
    )
  }
}
